import { render } from "./YesOutcome.vue?vue&type=template&id=07314499&ts=true"
import script from "./YesOutcome.vue?vue&type=script&lang=ts"
export * from "./YesOutcome.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__